import React, { useState } from 'react';
import { User, Lock, LogIn, RotateCcw } from 'lucide-react';
import AuthFormContainer from './AuthFormContainer';
import InputField from './InputField';

export default function LoginPage({ onLogin, setPage }) {
 const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
   if (email && password) {
  onLogin({ email, password }, setError, setLoading);
} else {
  setError('Please enter both email and password.');
}
  };

  return (
  <div className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-100 via-rose-50 to-teal-100 overflow-hidden">

    {/* 🌸 Floating Flower Decorations */}
    <div className="absolute top-10 left-10 text-6xl animate-bounce opacity-20">🌸</div>
    <div className="absolute bottom-20 right-16 text-5xl animate-pulse opacity-20">🌷</div>
    <div className="absolute top-1/3 right-10 text-4xl animate-bounce opacity-20">🌺</div>

    <div className="backdrop-blur-lg bg-white/70 shadow-2xl rounded-3xl p-8 w-full max-w-md border border-white/40 transition-all duration-500">

      {/* Logo / Brand */}
      <div className="text-center mb-6">
        <h1 className="text-3xl font-bold text-teal-700">🌼Create your Account</h1>
        <p className="text-sm text-gray-600 mt-2">
          Fresh Flowers Delivered 
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">

        {error && (
          <p className="text-sm text-red-600 text-center bg-red-100 p-3 rounded-lg">
            {error}
          </p>
        )}

        <InputField
          icon={<User />}
          name="email"
          type="email"
          placeholder="Enter Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <InputField
          icon={<Lock />}
          name="password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {/* Modern Sign In Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-teal-500 to-rose-400 hover:scale-105 transform transition duration-300 shadow-lg disabled:opacity-60"
        >
          {loading ? "Signing In..." : "Sign In 🌸"}
        </button>

        {/* Forgot Password */}
        <div className="text-right">
          <button
            type="button"
            onClick={() => setPage({ name: 'forgot' })}
            className="text-sm text-teal-600 hover:underline"
          >
            Forgot Password?
          </button>
        </div>

        {/* Register Link */}
        <div className="text-center text-sm mt-4">
          Don't have an account?{" "}
          <button
            onClick={() => setPage('register')}
            className="font-medium text-rose-500 hover:underline"
          >
            Register here
          </button>
        </div>

      </form>
    </div>
  </div>
);

}
